module.exports = __webpack_public_path__ + "img/point_title.ad51c2af.png";